"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIAccordionItem = _interopRequireDefault(require("UIComponents/accordion/UIAccordionItem"));

var Favorites =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Favorites, _React$Component);

  function Favorites() {
    (0, _classCallCheck2.default)(this, Favorites);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Favorites).apply(this, arguments));
  }

  (0, _createClass2.default)(Favorites, [{
    key: "onClickFavorite",
    value: function onClickFavorite(hex) {
      var onSelectColor = this.props.onSelectColor;
      onSelectColor({
        hex: hex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var favorites = this.props.favorites;
      if (favorites.length <= 0) return null;
      var favoritesComponents = favorites.map(function (f, counter) {
        var style = {
          backgroundColor: f
        };

        var handleClick = function handleClick() {
          _this.onClickFavorite(f);
        };

        return _react.default.createElement("div", {
          key: "favorite-" + counter,
          className: "private-react-colorpicker--preview",
          style: style,
          onClick: handleClick
        });
      });
      return _react.default.createElement(_UIAccordionItem.default, {
        defaultOpen: true,
        className: "private-react-colorpicker--favorites",
        title: _I18n.default.text('colorPicker.favorites'),
        contentClassName: "private-react-colorpicker--favorites-content"
      }, favoritesComponents);
    }
  }]);
  return Favorites;
}(_react.default.Component);

Favorites.propTypes = {
  favorites: _react.PropTypes.arrayOf(_react.PropTypes.string),
  onSelectColor: _react.PropTypes.func.isRequired
};
var _default = Favorites;
exports.default = _default;
module.exports = exports.default;